<template>
  <div>
    <CRow>
      <CCol sm="12">&nbsp;</CCol>
      <CCol sm="12">
        <GlobalTable
          :title="'Agent yang menggunakan voucher ini'"
          :fields="fields"
          :items="data"
          :editButton="true"
          :redirectDetail="false"
          :enableAddButton="voucherStatus === '3' ? true : false"
          :isLoading="isLoading"
          :withCard="false"
          @addForm="addForm"
          @editForm="editForm"
        ></GlobalTable>
      </CCol>
    </CRow>
    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <Loading v-if="isLoading"></Loading>
      <div v-else>
        <CRow>
          <CCol lg="4">
            <div class="form-group">
              <label for="voucher_agent"
                >Pilih agen yang ingin di berlakukan voucher</label
              >
              <model-select
                class="form-control"
                id="voucher_agent"
                :options="agentList"
                v-model="$v.voucherAgentForm.agent_code.$model"
                :isError="$v.voucherAgentForm.agent_code.$invalid"
                :isRequired="true"
                placeholder="-- Harap pilih salah satu --"
              ></model-select>
              <div
                v-if="$v.voucherAgentForm.agent_code.$invalid"
                class="invalid-feedback-custom"
              >
                Agent should be filled.
              </div>
            </div>
          </CCol>
        </CRow>
      </div>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.voucherAgentForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";
import { required } from "vuelidate/lib/validators";

export default {
  name: "VoucherAgent",
  components: { GlobalTable, Loading },
  data() {
    return {
      title: "Voucher Agent",
      items: [],
      addButton: false,
      isEdit: false,
      voucherAgentForm: tableInterfaces.agent_voucher,
      isLoading: false,
      image: null,
      activeTab: 0,
      fields: [
        { key: "agent_code", label: "Agent Code", sorter: true },
        { key: "name", label: "Agent Name", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
    };
  },
  props: {
    agentList: {
      type: [Array, Object],
      default: () => [],
    },
    voucherAgent: {
      type: [Array, Object],
      default: () => [],
    },
    voucherStatus: {
      type: String,
      default: null,
    },
    voucher: {
      type: [Array, Object],
      default: () => [],
    },
  },
  validations: {
    voucherAgentForm: {
      agent_code: { required },
      voucher_code: {}
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    data: function () {
      return this.items.length > 0 ? this.items : this.voucherAgent;
    },
  },
  methods: {
    init: function () {
      this.$emit("update:");
      // getProductList();
    },

    refreshVoucherAgent: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/voucher/voucher-agent/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.items = response.data.data;
            // if (response.data.total_row.total_row == 2) {
            //   this.enableAddPrice = false;
            // }
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.cancelForm();
        });
    },
    addForm: function () {
      this.addButton = true;
      this.isEdit = false;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.isEdit = true;
      this.voucherAgentForm = item;
      this.addButton = true;
    },
    resetForm: function () {
      for (var i in tableInterfaces.agent_voucher) {
        tableInterfaces.agent_voucher[i] = null;
      }
      this.voucherAgentForm = tableInterfaces.agent_voucher;
    },
    back: function () {
      this.$router.go(-1);
    },
    submitForm: function (event) {
      event.preventDefault();
      this.voucherAgentForm.voucher_code = this.voucher.voucher_code;
      if (this.isEdit === true) {
        if (confirm("Do you want to change this data ?")) {
          this.isLoading = true;
          this.axios
            .put(
              "console/voucher/voucher-agent/update",
              this.voucherAgentForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherAgent(this.voucher.id);
            });
        }
      } else {
        if (confirm("Do you want to add this data ?")) {
          this.isLoading = true;
          this.axios
            .post(
              "console/voucher/voucher-agent/add",
              this.voucherAgentForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: this.title,
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: this.title,
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.showErrorNotification({
                title: this.title,
                message: error,
              });
            })
            .finally(() => {
              this.isLoading = false;
              this.refreshVoucherAgent(this.voucher.id);
            });
        }
      }
    },
  },
  mounted() {},
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
